import { ToolsClass } from '@/common/class/tools.class'
import Vue from 'vue'

export const PAYWALL_RECURRING_ACTION = {
  auto: 'AUTO',
  manual: 'MANUAL',
  initWithRefund: 'INIT_WITH_REFUND',
  initWithPayment: 'INIT_WITH_PAYMENT'
}
export const PAYMENT_GROUP = {
  blik: 'BLIK',
  fastTransfer: 'FAST_TRANSFER',
  creditCard: 'CREDIT_CARD',
  wallet: 'WALLET'
}
export const PAYWAY_GROUP_MODEL = {
  id: null,
  type: null,
  header: null,
  description: null,
  payways: []
}
export const PAYWALL_BLIK_CODE_LENGTH = 6
export const BLIK_TYPES = {
  blik: {
    id: 509,
    label: 'BLIK'
  },
  blikRecurring: {
    id: 524,
    label: 'BLIK Recurring'
  }
}
export const BLIK_ID_LIST = [
  BLIK_TYPES.blik.id
]
export const WALLET_TYPES = {
  visaCheckout: {
    id: 1511,
    label: 'Visa Checkout'
  },
  googlePay: {
    id: 1512,
    label: 'Google Pay'
  },
  applePay: {
    id: 1513,
    label: 'Apple Pay'
  },
  masterPass: {
    id: 1505,
    label: 'MasterPass'
  },
  visaMobile: {
    id: 1523,
    label: 'Visa Mobile'
  }
}
export const WALLET_ID_LIST = [
  WALLET_TYPES.visaCheckout.id,
  WALLET_TYPES.googlePay.id,
  WALLET_TYPES.applePay.id,
  WALLET_TYPES.masterPass.id,
  WALLET_TYPES.visaMobile.id
]
export const CARD_TYPES = {
  creditCard: {
    id: 1500,
    label: 'Credit Card'
  },
  autoCreditCard: {
    id: 1503,
    label: 'Credit Card Recurring'
  }
}
export const CARD_ID_LIST = [
  CARD_TYPES.creditCard.id
]
export const PIS_PAYWAY_RANGE = {
  start: 1800,
  end: 1899
}
export const PAYWAY_EXCLUDED_LIST = [
  BLIK_TYPES.blikRecurring.id,
  CARD_TYPES.autoCreditCard.id
]
export const paywayGroupsList = () => {
  const PAYWAY_GROUPS = [
    {
      type: PAYMENT_GROUP.blik,
      header: Vue.i18n.translate('paywall.groupBlik.header'),
      description: Vue.i18n.translate('paywall.groupBlik.description')
    },
    {
      type: PAYMENT_GROUP.fastTransfer,
      header: Vue.i18n.translate('paywall.groupFastTransfer.header'),
      description: Vue.i18n.translate('paywall.groupFastTransfer.description')
    },
    {
      type: PAYMENT_GROUP.creditCard,
      header: Vue.i18n.translate('paywall.groupCreditCard.header'),
      description: Vue.i18n.translate('paywall.groupCreditCard.description')
    },
    {
      type: PAYMENT_GROUP.wallet,
      header: Vue.i18n.translate('paywall.groupWallet.header'),
      description: Vue.i18n.translate('paywall.groupWallet.description')
    }
  ]
  const groups = []
  PAYWAY_GROUPS.forEach(group => {
    const newGroupModel = ToolsClass.deepExtend(PAYWAY_GROUP_MODEL)
    const newGroup = Object.assign({}, newGroupModel, group)
    newGroup.id = ToolsClass.generateUUID()
    groups.push(newGroup)
  })
  return groups
}
